type TEl = string | null | undefined | Array<any> | number;
type TOpts = {
	stringToNum?: boolean;
}

export const isEmpty = (el: TEl, opts?: TOpts) => {
	if (typeof el === 'string') {
		if (opts && opts.stringToNum) {
			const val = Number(el);
			return val === 0;
		}
		return el === '';
	}
	if (typeof el === 'number') return el === 0;
	if (Array.isArray(el)) return el.length === 0;
	if (!el) return true;
	return false;
}
